// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader{animation:spin 2s linear infinite;border-bottom:12px solid #f3f3f3;border-top:12px solid #f3f3f3;border-color:#3498db #f3f3f3;border-radius:50%;border-style:solid;border-width:12px;height:120px;margin:0 auto;width:120px}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
